var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManatSign(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 384 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M368 272V471.531C368 475.938 364.422 479.531 360 479.531S352 475.938 352 471.531V272C352 228.469 334.828 187.75 303.625 157.375C275.402 129.916 238.924 114.99 200 112.977V472C200 476.406 196.422 480 192 480S184 476.406 184 472V112.535C98.514 116.801 32 185.93 32 272V472C32 476.406 28.422 480 24 480S16 476.406 16 472V272C16 177.029 89.564 100.746 184 96.48V40C184 35.594 187.578 32 192 32S200 35.594 200 40V97.012C243.18 99.066 283.539 115.488 314.797 145.906C349.109 179.344 368 224.094 368 272Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManatSign);
export default __webpack_public_path__ + "static/media/manat-sign.35ead2df85344f5b6ed3acef29e83dd3.svg";
export { ForwardRef as ReactComponent };